import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface BusinessTypeSelectProps {
  businessTypes: any[];
  selectedBusinessType: string;
  onBusinessTypeChange: (value: string) => void;
}

export const BusinessTypeSelect = ({
  businessTypes,
  selectedBusinessType,
  onBusinessTypeChange,
}: BusinessTypeSelectProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="businessType">Type d'entreprise</Label>
      <Select
        value={selectedBusinessType}
        onValueChange={onBusinessTypeChange}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Sélectionnez un type d'entreprise" />
        </SelectTrigger>
        <SelectContent>
          {businessTypes?.map((type) => (
            <SelectItem key={type.id} value={type.id}>
              {type.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!selectedBusinessType && (
        <p className="mt-1 text-sm text-red-500">
          Veuillez sélectionner un type d'entreprise avant de vous inscrire
        </p>
      )}
    </div>
  );
};